import { render } from "./perfilTable.vue?vue&type=template&id=fece423a&scoped=true"
import script from "./perfilTable.vue?vue&type=script&lang=js"
export * from "./perfilTable.vue?vue&type=script&lang=js"

import "./perfilTable.vue?vue&type=style&index=0&id=fece423a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fece423a"]])

export default __exports__